module.exports = __webpack_public_path__ + "static/media/other2.fa5c1695.jpg";